<template>
  <div
    v-loading.fullscreen.lock="loading"
    style=""
    class="homeTamplate"
    ref="homeTamplate"
  >
    <div style="" class="homefixed">
      <div class="searchInput" v-if="!MapFlag">
        <el-button-group
          v-if="!MapFlag"
          style="
            width: 50%;
            padding: 5px;
            margin-right: 60px;
            background-color: #ffffff;
            border-radius: 5rem;
            display: flex;
            justify-content: center;
          "
        >
          <el-button
            :style="` border-radius: 5rem;background-color: ${
              radio1 == 'all' ? '#409EFF' : '#ffffff'
            };
              color:${radio1 == 'all' ? '#ffffff' : '#000'};
              border:1px solid ${radio1 == 'all' ? '#409EFF' : '#ffffff'}
              `"
            @click="tabChick('all')"
            >全部</el-button
          >
          <el-button
            type=""
            :style="` border-radius: 5rem;background-color: ${
              radio1 == '0' ? '#409EFF' : '#ffffff'
            };
              color:${radio1 == '0' ? '#ffffff' : '#000'}; border:1px solid ${
              radio1 == '0' ? '#409EFF' : '#ffffff'
            }`"
            @click="tabChick('0')"
            >新建</el-button
          >
          <el-button
            type=""
            :style="` border-radius: 5rem;background-color: ${
              radio1 == '1' ? '#409EFF' : '#ffffff'
            };
              color:${radio1 == '1' ? '#ffffff' : '#000'}; border:1px solid ${
              radio1 == '1' ? '#409EFF' : '#ffffff'
            }`"
            @click="tabChick('1')"
            >进行中</el-button
          >
          <el-button
            type=""
            :style="` border-radius: 5rem;background-color: ${
              radio1 == '2' ? '#409EFF' : '#ffffff'
            };
              color:${radio1 == '2' ? '#ffffff' : '#000'}; border:1px solid ${
              radio1 == '2' ? '#409EFF' : '#ffffff'
            }`"
            @click="tabChick('2')"
            >完成</el-button
          >

          <!-- <el-button
            type=""
            :style="` border-radius: 5rem;background-color: ${
              radio1 == '99' ? '#409EFF' : '#ffffff'
            };
              color:${radio1 == '99' ? '#ffffff' : '#000'}; border:1px solid ${
              radio1 == '99' ? '#409EFF' : '#ffffff'
            }`"
            @click="tabChick('99')"
            >关闭</el-button
          > -->
        </el-button-group>
        <el-input
          v-model="queryParam.Keyword"
          class="input"
          clearable
          size="small"
          placeholder="请输入项目名称进行查询"
          @keydown.enter.native="search"
        ></el-input>
        <el-button class="btn" size="small" type="primary" @click="search"
          >查询</el-button
        >
      </div>
      <div style="width: 50%" v-if="MapFlag"></div>
      <div class="tabfixed">
        <el-button size="small" type="primary" @click="handleAdd"
          >新建项目</el-button
        >
        <div
          style="
            display: inline-block;
            margin-left: 10px;
            font-size: 14px;
            color: #333;
            background-color: #fff;
          "
        >
          <el-button-group>
            <el-button
              :type="MapFlag ? 'info' : 'primary'"
              @click="handleMap(false)"
              style="padding: 5px; width: 40px"
            >
              <img :src="liebiao" alt="" style="width: 20px; height: 20px" />
            </el-button>
            <el-button
              :type="!MapFlag ? 'info' : 'primary'"
              @click="handleMap(true)"
              style="padding: 5px; width: 40px"
            >
              <img :src="dotu" alt="" style="width: 20px; height: 20px" />
            </el-button>
          </el-button-group>
        </div>
      </div>
    </div>
    <div style="height: 60px"></div>
    <div style="" class="List" v-if="!MapFlag" ref="List">
      <div style="width: 100%; display: flex">
        <div style="width: calc(100% - 400px)">
          <el-table
            :data="List"
            style="width: 100%"
            size="medium"
            header-row-class-name="header-row"
            row-class-name="row"
            @row-click="handleRowClick"
          >
            <el-table-column prop="info" label="项目基本信息">
              <template slot-scope="scope">
                <div
                  style="
                    width: 100%;
                    box-sizing: border-box;
                    padding-right: 20px;
                  "
                >
                  <div
                    style="width: 100%; display: flex; box-sizing: border-box"
                  >
                    <div>
                      <el-image
                        :src="getProjectImg(scope.row)"
                        class="image"
                        fit="cover"
                        style="width: 100px; height: 100px; border-radius: 10px"
                      >
                      </el-image>
                    </div>
                    <div style="margin-left: 10px; width: calc(100% - 120px)">
                      <div
                        class="ellipsis"
                        style="
                          font-size: 18px;
                          color: #409eff;
                          font-weight: bold;
                          margin-bottom: 5px;
                        "
                        :title="scope.row.Name"
                      >
                        {{ scope.row.Name }}
                      </div>
                      <div class="ellipsis2" :title="scope.row.Code">
                        <span style="font-weight: bold">项目编号：</span>
                        {{ scope.row.Code }}
                      </div>
                      <div class="ellipsis2" :title="scope.row.Describe">
                        <span style="font-weight: bold">项目描述：</span>
                        {{ scope.row.Describe }}
                      </div>
                      <div
                        style="line-height: 20px; font-size: 12px"
                        class="ellipsis"
                      >
                        <span :title="scope.row.TotalArea"
                          ><span style="font-weight: bold">建筑面积：</span
                          ><span v-if="scope.row.TotalArea"
                            >{{ scope.row.TotalArea || '' }} m²</span
                          ></span
                        >
                        <span style="margin: 0 10px">|</span>
                        <span
                          :title="`${scope.row.Province || ''} ${
                            scope.row.City || ''
                          }`"
                          ><span style="font-weight: bold">位置：</span
                          >{{ scope.row.Province || '' }}
                          {{ scope.row.City || '' }}</span
                        >
                        <span style="margin: 0 10px">|</span>
                        <span
                          :title="
                            scope.row.OpeningTime
                              ? moment(scope.row.OpeningTime).format(
                                  'YYYY年MM月DD日'
                                )
                              : ''
                          "
                          ><span style="font-weight: bold">开工：</span
                          >{{
                            scope.row.OpeningTime
                              ? moment(scope.row.OpeningTime).format(
                                  'YYYY年MM月DD日'
                                )
                              : ''
                          }}</span
                        >
                        <span style="margin: 0 10px">|</span>
                        <span
                          :title="
                            scope.row.PlannedCompletionDate
                              ? moment(scope.row.PlannedCompletionDate).format(
                                  'YYYY年MM月DD日'
                                )
                              : ''
                          "
                          ><span style="font-weight: bold">完工：</span
                          >{{
                            scope.row.PlannedCompletionDate
                              ? moment(scope.row.PlannedCompletionDate).format(
                                  'YYYY年MM月DD日'
                                )
                              : ''
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      line-height: 20px;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      font-size: 12px;
                      color: #999;
                      margin-bottom: 5px;
                    "
                  >
                    <span class="footerleft">{{
                      scope.row.CreatorRealName
                    }}</span>
                    <span class="footerleft"
                      >供应商数量：{{ scope.row.SupplierCount }}</span
                    >
                    <span class="footerright"
                      >创建时间：{{
                        scope.row.CreateTime
                          ? timeDataFormat(scope.row.CreateTime, 'YYYY-MM-DD ')
                          : ''
                      }}</span
                    >
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="HandoverTime"
              label="计划移交"
              width="180"
              align="center"
              sortable
            >
              <template slot-scope="scope">
                <span style="font-size: 12px">
                  {{
                    scope.row.HandoverTime
                      ? moment(scope.row.HandoverTime).format('YYYY年MM月DD日')
                      : ''
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="物业单位"
              width="230"
              header-align="center"
              sortable
            >
              <template slot-scope="scope">
                <div
                  style="width: 100%; display: flex; align-items: center"
                  v-if="scope.row.PMC_Phone"
                >
                  <div>
                    <el-avatar
                      :size="40"
                      :src="
                        scope.row.PMC_Img ||
                        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                      "
                    ></el-avatar>
                  </div>
                  <div
                    style="
                      width: calc(100% - 50px);
                      text-align: left;
                      margin-left: 10px;
                    "
                  >
                    <div style="color: #606266">
                      {{ scope.row.Property_Company }}
                    </div>
                    <div style="color: #000">{{ scope.row.PMC_Phone }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="addres2s"
              label="建设单位"
              width="230"
              sortable
            >
              <template slot-scope="scope">
                <div style="width: 100%; display: flex; align-items: center">
                  <div
                    style="
                      width: calc(100%);
                      text-align: left;
                      margin-left: 10px;
                    "
                  >
                    <div style="color: #606266">
                      {{ scope.row.ConstructionUnit }}
                    </div>

                    <div style="color: #000">
                      {{ scope.row.ConstructionPhone }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ProjectStatus"
              label="状态"
              width="180"
              align="center"
              sortable
            >
              <template slot-scope="scope">
                <el-tag
                  size="medium"
                  style="width: 70%"
                  v-if="scope.row.ProjectStatus == 0"
                  >新建</el-tag
                >
                <el-tag
                  type="warning"
                  size="medium"
                  style="width: 70%"
                  v-if="scope.row.ProjectStatus == 1"
                  >进行中</el-tag
                >

                <el-tag
                  type="success"
                  size="medium"
                  style="width: 70%"
                  v-if="scope.row.ProjectStatus == 2"
                  >完成</el-tag
                >
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px; height: 100px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="currentChange"
              background
              :current-page="pagination.PageIndex"
              :page-sizes="pagination.pageSizeOptions"
              :page-size="pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
          <!-- <div style="width: calc(80% - 500px)">
            <h1>项目基本信息</h1>
            <el-tag size="medium" effect="light">项目基本信息</el-tag>
          </div>
          <div style="width: 20%">
            <h1>计划完工</h1>
          </div>
          <div style="width: 200px">
            <h1>物业单位</h1>
          </div>
          <div style="width: 200px">
            <h1>项目经理</h1>
          </div>
          <div style="width: 100px">
            <h1>状态</h1>
          </div> -->
        </div>
        <div style="width: 300px; margin-left: 100px">
          <div style="width: 100%">
            <div
              style="font-size: 18px; font-weight: bold; margin-bottom: 10px"
            >
              项目统计 ( 项目总量 : &nbsp;{{ projectTotal }} )
            </div>
            <div
              ref="projectStatistics"
              style="width: 100%; height: 200px"
            ></div>
          </div>
          <div style="width: 100%">
            <div
              style="font-size: 18px; font-weight: bold; margin-bottom: 10px"
            >
              动态
            </div>
            <el-timeline
              v-if="ProjectRecordDataList.length > 0"
              style="font-size: 12px"
            >
              <el-timeline-item
                v-for="item in ProjectRecordDataList"
                :key="item.Id"
                :timestamp="
                  moment(item.ModifyDate).format('YYYY-MM-DD HH:mm:ss')
                "
                placement="top"
              >
                <span>{{
                  moment(item.ModifyDate).format('YYYY-MM-DD HH:mm:ss')
                }}</span
                >修改了项目：<span style="font-weight: bold; font-size: 14px">{{
                  item.Name
                }}</span
                >当前项目状态为：<span
                  style="font-weight: bold; font-size: 14px"
                  >{{
                    item.ProjectStatus == 0
                      ? '新建'
                      : item.ProjectStatus == 1
                      ? '进行中'
                      : '完成'
                  }}</span
                >
              </el-timeline-item>
            </el-timeline>
            <div v-else>
              <el-empty description="暂无动态"></el-empty>
            </div>
          </div>
          <div style="height: 60px"></div>
        </div>
      </div>
    </div>
    <div class="MapData" v-if="MapFlag">
      <div
        ref="china_map"
        style="height: 100%; width: 100%"
        :class="MapFlag ? '' : 'mapnone'"
      ></div>
      <el-button
        v-if="Level == 1"
        @click="handleReturn"
        style="position: absolute; left: 10px; top: 10px; z-index: 999"
        type="primary"
        >返回全国地图</el-button
      >
    </div>
    <el-drawer
      title="新建项目"
      :visible.sync="drawer"
      @close="close"
      size="70%"
      :close-on-press-escape="false"
      :wrapper-closable="false"
    >
      <div style="padding: 10px" v-loading="formLoading">
        <el-form
          :model="entity"
          :rules="rules"
          ref="entity"
          label-width="120px"
          class="addProjectForm"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                label="项目效果图"
                prop="ProjectImg"
                class="Describe"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="
                    $rootUrl +
                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?UserId=${userInfo.Id}&Type=0`
                  "
                  :headers="{
                    Authorization: token,
                  }"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <el-image
                    v-if="entity.ProjectImg"
                    fit="contain"
                    class="projectImg"
                    :src="entity.ProjectImg"
                  ></el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目简码" prop="SimplifiedCode">
                <el-input
                  v-model="entity.SimplifiedCode"
                  disabled
                  placeholder="系统自动生成"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="Name">
                <el-input
                  v-model="entity.Name"
                  placeholder="请输入项目名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目描述" prop="Describe" class="Describe">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入项目描述"
                  v-model="entity.Describe"
                  style="font-family: Arial"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="所在城市省份" prop="Province">
                <el-select
                  class="flex:1"
                  v-model="entity.Province"
                  placeholder="请选择省"
                  @change="changeProvince"
                  filterable
                >
                  <el-option
                    v-for="item in ProvinceLsit"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在城市市区" prop="City">
                <el-select
                  class="flex:1"
                  v-model="entity.City"
                  placeholder="请选择市"
                  filterable
                >
                  <el-option
                    v-for="item in CityLsit"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="项目类型" prop="ProjectType">
                <el-select v-model="entity.ProjectType" filterable>
                  <el-option
                    v-for="item in ProjectTypeList"
                    :key="item.Id"
                    :label="item.DicName"
                    :value="item.DicName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建筑总面积" prop="TotalArea">
                <el-input v-model="entity.TotalArea" type="number">
                  <span slot="suffix">m²</span>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="开工时间" prop="OpeningTime">
                <el-date-picker
                  v-model="entity.OpeningTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="计划完工" prop="OpeningTime">
                <el-date-picker
                  v-model="entity.PlannedCompletionDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="计划移交时间" prop="OpeningTime">
                <el-date-picker
                  v-model="entity.HandoverTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="项目经理" prop="ProjectManagerId">
                <el-select v-model="entity.ProjectManagerId" filterable>
                  <el-option
                    v-for="item in UserList"
                    :key="item.Id"
                    :label="
                      item.NickName
                        ? `${item.NickName}(${item.Phone})`
                        : item.Name
                        ? `${item.Name}(${item.Phone})`
                        : item.Phone
                    "
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物业单位" prop="Property_Company">
               
                  <el-input
                    v-model="entity.Property_Company"
                    style="width: calc(100% - 70px);"
                    disabled
                  >
                  </el-input>
                  <el-button
                    type="primary"
                    
                    style="width: 60px; margin-left: 6px;height: 100%;"
                    @click="openDialog"
                    >选择</el-button
                  >
               
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建设单位" prop="TotalArea">
                <el-input v-model="entity.ConstructionUnit"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建设单位联系人" prop="TotalArea">
                <el-input v-model="entity.ConstructionManager"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建设单位手机号" prop="TotalArea">
                <el-input v-model="entity.ConstructionPhone" type="number">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="height: 60px"></div>
      </div>
      <div
        style="
          height: 60px;
          position: fixed;
          bottom: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: right;
          background-color: #fff;
        "
      >
        <el-button style="margin-right: 10px" @click="close">取消</el-button>
        <el-button style="margin-right: 20px" type="primary" @click="SaveAdd"
          >保存</el-button
        >
      </div>
    </el-drawer>
    <el-drawer
      title="项目信息"
      modal-append-to-body
      :visible.sync="projectDrawer"
      @close="closeProjectDrawer"
      size="80%"
    >
      <div style="padding: 10px" v-loading="projectDrawerLoading">
        <el-table
          :data="DrawerList"
          style="width: 100%"
          size="medium"
          header-row-class-name="header-row"
          row-class-name="row"
          @row-click="handleRowClick"
        >
          <el-table-column prop="info" label="项目基本信息">
            <template slot-scope="scope">
              <div
                style="width: 100%; box-sizing: border-box; padding-right: 20px"
              >
                <div style="width: 100%; display: flex; box-sizing: border-box">
                  <div>
                    <el-image
                      :src="getProjectImg(scope.row)"
                      class="image"
                      fit="cover"
                      style="width: 100px; height: 100px; border-radius: 10px"
                    >
                    </el-image>
                  </div>
                  <div style="margin-left: 10px; width: calc(100% - 120px)">
                    <div
                      class="ellipsis"
                      style="
                        font-size: 18px;
                        color: #409eff;
                        font-weight: bold;
                        margin-bottom: 5px;
                      "
                      :title="scope.row.Name"
                    >
                      {{ scope.row.Name }}
                    </div>
                    <div class="ellipsis2" :title="scope.row.Code">
                      <span style="font-weight: bold">项目编号：</span>
                      {{ scope.row.Code }}
                    </div>
                    <div class="ellipsis2" :title="scope.row.Describe">
                      <span style="font-weight: bold">项目描述：</span>
                      {{ scope.row.Describe }}
                    </div>
                    <div
                      style="line-height: 20px; font-size: 12px"
                      class="ellipsis"
                    >
                      <span
                        v-if="scope.row.TotalArea"
                        :title="scope.row.TotalArea"
                        ><span style="font-weight: bold">建筑面积：</span
                        >{{ scope.row.TotalArea }} m²</span
                      >
                      <span
                        v-if="
                          scope.row.TotalArea &&
                          (scope.row.Province || scope.row.City)
                        "
                        style="margin: 0 10px"
                        >|</span
                      >
                      <span
                        v-if="scope.row.Province || scope.row.City"
                        :title="`${scope.row.Province || ''} ${
                          scope.row.City || ''
                        }`"
                        ><span style="font-weight: bold">位置：</span
                        >{{ scope.row.Province }} {{ scope.row.City }}</span
                      >
                      <span
                        v-if="
                          scope.row.OpeningTime &&
                          (scope.row.Province || scope.row.City)
                        "
                        style="margin: 0 10px"
                        >|</span
                      >
                      <span v-if="scope.row.OpeningTime"
                        ><span style="font-weight: bold">开工：</span
                        >{{
                          moment(scope.row.OpeningTime).format('YYYY年MM月DD日')
                        }}</span
                      >
                      <span
                        v-if="
                          scope.row.OpeningTime &&
                          scope.row.PlannedCompletionDate
                        "
                        style="margin: 0 10px"
                        >|</span
                      >
                      <span v-if="scope.row.PlannedCompletionDate"
                        ><span style="font-weight: bold">完工：</span
                        >{{
                          moment(scope.row.PlannedCompletionDate).format(
                            'YYYY年MM月DD日'
                          )
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  style="
                    line-height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 12px;
                    color: #999;
                    margin-bottom: 5px;
                  "
                >
                  <span class="footerleft">{{
                    scope.row.CreatorRealName
                  }}</span>
                  <span class="footerleft"
                    >供应商数量：{{ scope.row.SupplierCount }}</span
                  >
                  <span class="footerright"
                    >创建时间：{{
                      scope.row.CreateTime
                        ? timeDataFormat(scope.row.CreateTime, 'YYYY-MM-DD ')
                        : ''
                    }}</span
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="HandoverTime"
            label="计划移交"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <span style="font-size: 12px">
                {{
                  scope.row.HandoverTime
                    ? moment(scope.row.HandoverTime).format('YYYY年MM月DD日')
                    : ''
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="物业单位"
            width="180"
            header-align="center"
          >
            <template slot-scope="scope">
              <div
                style="width: 100%; display: flex; align-items: center"
                v-if="scope.row.PMC_Phone"
              >
                <div>
                  <el-avatar
                    :size="40"
                    :src="
                      scope.row.PMC_Img ||
                      'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                    "
                  ></el-avatar>
                </div>
                <div
                  style="
                    width: calc(100% - 50px);
                    text-align: left;
                    margin-left: 10px;
                  "
                >
                  <div style="color: #606266">
                    {{ scope.row.Property_Company }}
                  </div>
                  <div style="color: #000">{{ scope.row.PMC_Phone }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="addres2s" label="建设单位" width="180">
            <template slot-scope="scope">
              <div style="width: 100%; display: flex; align-items: center">
                <div
                  style="width: calc(100%); text-align: left; margin-left: 10px"
                >
                  <div style="color: #606266">
                    {{ scope.row.ConstructionUnit }}
                  </div>

                  <div style="color: #000">
                    {{ scope.row.ConstructionPhone }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="addres22s"
            label="状态"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="medium"
                style="width: 50%"
                v-if="scope.row.ProjectStatus == 0"
                >新建</el-tag
              >
              <el-tag
                type="warning"
                size="medium"
                style="width: 50%"
                v-if="scope.row.ProjectStatus == 1"
                >进行中</el-tag
              >

              <el-tag
                type="success"
                size="medium"
                style="width: 50%"
                v-if="scope.row.ProjectStatus == 2"
                >完成</el-tag
              >
            </template>
          </el-table-column>
        </el-table>

        <div style="height: 90px"></div>
      </div>
      <div
        style="
          position: fixed;
          bottom: 0;
          right: 0;
          width: 33%;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: right;
          background-color: #fff;
          z-index: 999;
        "
      >
        <el-button style="margin-right: 10px" @click="closeProjectDrawer"
          >取消</el-button
        >
      </div>
    </el-drawer>

    <PMCSelect ref="PMCSelect" @select="dialogContact" type="radio" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import folderImg from '@/assets/folder.png'
import addfolderImg from '@/assets/Addfolder.png'
import Token from '@/utils/cache/TokenCache.js'
import PMCSelect from '@/components/PMCSelect.vue'
import * as echarts from 'echarts'

import dotu from '@/assets/ditu.png'

import liebiao from '@/assets/liebiao.png'
import moment from 'moment'
import './china.js' // 核心文件
require('echarts/theme/macarons') //
export default {
  data() {
    return {
      radio1: 'all',
      liebiao,
      moment,
      dotu,
      projectStatisticsChart: null,
      projectTotal: 0,
      deviceTotal: 0,
      documentTotal: 0,
      supplierTotal: 0,
      ProjectTypeList: [],
      SupplierQualificationsList: [],
      isReturnChina: false,
      provinces: {
        // 数据
        台湾: 'taiwan',
        河北: 'hebei',
        山西: 'shanxi',
        辽宁: 'liaoning',
        吉林: 'jilin',
        黑龙江: 'heilongjiang',
        江苏: 'jiangsu',
        浙江: 'zhejiang',
        安徽: 'anhui',
        福建: 'fujian',
        江西: 'jiangxi',
        山东: 'shandong',
        河南: 'henan',
        湖北: 'hubei',
        湖南: 'hunan',
        广东: 'guangdong',
        海南: 'hainan',
        四川: 'sichuan',
        贵州: 'guizhou',
        云南: 'yunnan',
        陕西: 'shanxi1',
        甘肃: 'gansu',
        青海: 'qinghai',
        新疆: 'xinjiang',
        广西: 'guangxi',
        内蒙古: 'neimenggu',
        宁夏: 'ningxia',
        西藏: 'xizang',
        北京: 'beijing',
        天津: 'tianjin',
        上海: 'shanghai',
        重庆: 'chongqing',
        香港: 'xianggang',
        澳门: 'aomen',
      },
      ProvincesId: '',
      ProvincesName: '',
      Level: 0,
      AreaType: null,
      params: {},
      MapFlag: false,
      rules: {
        ProjectImg: [
          { required: true, message: '请上传项目效果图', trigger: 'change' },
        ],
        Name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        
        Province: [
          { required: true, message: '请选择所在城市省份', trigger: 'change' },
        ],
        City: [
          { required: true, message: '请选择所在城市市区', trigger: 'change' },
        ],
        SupplierQualificationsList: [
          {
            required: true,
            message: '请选择项目所需资料类型',
            trigger: 'change',
          },
        ],
        ProjectManagerId: [
          { required: true, message: '请选择项目经理', trigger: 'change' },
        ],
      },
      vipuser: {},
      isSearch: false,
      // 是否显示空状态
      isShow: false,
      activeName: 'All',
      restaurants: [],
      List: [],
      loading: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        total: 0,
        SortField: 'CreateTime',
        SortType: 'desc',
        pageSizeOptions: [20, 50, 80, 100],
      },
      queryParam: {
        Condition: 'Name',
        Keyword: '',
        ProjectStatus: '',
      },

      folderImg,
      drawer: false,
      entity: {
        ProjectImg: '',
        SimplifiedCode: '',
        Name: '',
        Describe: '',
        Province: '',
        City: '',
        ProjectType: '',
        TotalArea: '',
        OpeningTime: '',
        PlannedCompletionDate: '',
        HandoverTime: '',
        ProjectManagerId: '',
        Property_Company: '',
        Property_Manager: '',
        ConstructionUnit: '',
        ConstructionManager: '',
        ConstructionPhone: '',
        Contact_Phone: '',
        PMCId: '',
        SupplierQualificationsList: [],
      },
      ProvinceLsit: [],
      CityLsit: [],
      formLoading: false,
      projectDrawer: false,
      projectDrawerLoading: false,
      DrawerList: [],
      token: '',
      ProjectRecordDataList: [],
      echartsBar: [],
      UserList: [],
    }
  },
  components: {
    PMCSelect,
  },
  computed: {
    ...mapState(['userInfo']),
    // 绑定项目图片
    getProjectImg: () => {
      return (item) =>
        item ? (item.ProjectImg ? item.ProjectImg : folderImg) : addfolderImg
    },
    getSearchResultHight() {
      return Number(document.body.offsetHeight - 300)
    },
  },
  created() {
    //获取项目经理列表
    this.getUserList()
  },
  mounted() {
    this.vipuser = this.userInfo
    this.token = 'Bearer ' + Token.getToken()
    if (!this.MapFlag) {
      this.getDataList()
      this.getProvince()
    } else {
      this.getMapData()
    }
    this.$nextTick(() => {
      this.initProjectStatisticsChart()
    })
  },
  beforeDestroy() {
    if (this.projectStatisticsChart) {
      this.projectStatisticsChart.dispose()
    }
  },
  methods: {
    dialogContact(arr) {
      console.log(arr)
      this.$set(this.entity, 'PMCId', arr[0].Id)
      this.$set(this.entity, 'Property_Company', arr[0].PMC_Name)
      this.$set(this.entity, 'Property_Manager', arr[0].PMC_Person)
      this.$set(this.entity, 'Contact_Phone', arr[0].PMC_Phone)
    },
    getUserList() {
      this.$http
        .post('/Base_Manage/Base_VIPUserInfo/GetDataList', {})
        .then((res) => {
          if (res.Success) {
            this.UserList = res.Data
          }
        })
    },
    openDialog(text) {
      let str = typeof text == 'string' ? text : ''
      this.$refs.PMCSelect.open(str)
    },
    tabChick(num) {
      this.radio1 = num
      if (num == 'all') {
        this.queryParam.ProjectStatus = ''
      } else {
        this.queryParam.ProjectStatus = num
      }

      this.getDataList()
    },
    handleRowClick(row) {
      this.handleView(row)
    },
    initProjectStatisticsChart() {
      this.projectStatisticsChart = echarts.init(this.$refs.projectStatistics)
      this.updateProjectStatisticsChart()
    },
    updateProjectStatisticsChart() {
      let option = {
        legend: {
          data: [],
          top: 0,
        },
        grid: {
          top: 60,
          left: 60,
          bottom: '4%',
        },
        tooltip: {
          appendToBody: true,
          trigger: 'item',
        },

        xAxis: {
          // show: false,
          type: 'category',
          data: [],
        },
        yAxis: {
          // name: "变更次数",
          // nameLocation: "end",
          // nameTextStyle: {
          //   width: 200,
          //   align: "right",
          // },
          // axisLabel: {
          //   formatter: "{value} 次",
          // },
          axisLine: {
            //坐标轴轴线
            show: true,
          },
          axisTick: {
            //坐标轴刻度
            show: true,
          },
          show: true,
          type: 'value',
        },
        label: {
          show: true,
          position: 'top',
          formatter: `{c}`,
        },
        series: [],
      }
      console.log(this.echartsBar, 'this.echartsBar')
      this.echartsBar.forEach((item) => {
        option.legend.data.push(item.name)
        let color = ''
        if (item.name === '新建') {
          color = '#409EFF'
        } else if (item.name === '进行中') {
          color = '#E6A23C'
        } else if (item.name === '完成') {
          color = '#67C23A'
        }
        option.series.push({
          name: item.name,
          data: [item.value],
          type: 'bar',
          emphasis: {
            focus: 'series',
          },
          barGap: '100%',
          showBackground: true,
          itemStyle: {
            color: color,
          },
          backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
          },
        })
      })

      this.projectStatisticsChart.setOption(option)
    },
    getProjectStatistics() {
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetProjectStatistics', {})
        .then((res) => {
          if (res.Success) {
            this.projectTotal = res.Data.total || 0

            this.echartsBar = res.Data.list || []
            this.ProjectRecordDataList = res.Data.projectdata || []

            this.$nextTick(() => {
              this.initProjectStatisticsChart()
            })
          }
        })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.code == 200) {
        this.entity.ProjectImg = res.url
        this.entity.Id = res.ProjectId
        console.log(this.entity.ProjectImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getprojectDrawerData() {
      this.projectDrawerLoading = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetProjectDataList', {
          SortField: 'ModifyDate',
          SortType: 'desc',
          Search: {
            Condition: 'City',
            Keyword: this.ProvincesName,
          },
        })
        .then((res) => {
          if (res.Success) {
            this.DrawerList = res.Data
            this.projectDrawerLoading = false
          } else {
            this.projectDrawerLoading = false
            this.$notify.error(res.Message)
          }
        })
    },
    closeProjectDrawer() {
      this.projectDrawer = false
    },
    handleReturn() {
      this.Level = 0
      this.AreaType = null
      this.ProvincesId = ''
      this.getMapData()
    },
    getCityList(params) {
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetProjectListForMap', {
          Level: '2',
          ParentId: params.data.Id,
        })
        .then((res) => {
          if (res.Success) {
            const mapData = res.Data
            // const eData = res.Data.eData;
            const eData = mapData.map((item) => ({
              name: item.name,
              value: [item.Longitude, item.Latitude],
              num: item.value,
              visualMap: false,
              Id: item.Id,
            }))
            this.chinaMaprsult(params.name, mapData, eData)
          }
        })
    },
    // 渲染地图
    chinaMaprsult(name = null, mapData, eData) {
      name == 'china'
        ? (this.isReturnChina = false)
        : (this.isReturnChina = true)
      this.chinaMap = echarts.init(this.$refs.china_map)
      this.options = {
        tooltip: {
          appendToBody: true,
          formatter: function (params) {
            console.log(params, 'params')
            if (params.seriesType === 'map') {
              return `<span>${params.data.name}</span><br/><span>项目数：${
                params.data.value || 0
              }</span>`
            } else {
              return `<span>${params.data.name}</span><br/><span>项目数：${
                params.data.num || 0
              }</span>`
            }
          },
        },
        geo: {
          map: name || 'china', // 核心
          roam: false,

          label: {
            show: true,
            // position: "top",
            // distance: 1,
            align: 'right',
            color: '#000',
            fontSize: 14,
          },
          select: {
            itemStyle: {
              color: '#409EFF',
            },

            label: {
              show: true, // 是否显示标签
              color: '#fff',
            },
          },
          itemStyle: {
            borderWidth: 0.3,
            borderColor: 'rgba(119, 156, 255, 1)',
          },
          emphasis: {
            label: {
              show: true,
              color: '#fff', // 滑入时的字体颜色
            },
            itemStyle: {
              areaColor: '#409EFF',
            },
          },
        },
        // 地图
        series: [
          {
            type: 'map',
            geoIndex: 0,
            itemStyle: {
              // 地图区域的多边形 图形样式
              // normal: {
              //   // 是图形在默认状态下的样式
              //   label: {
              //     show: true, // 是否显示标签
              //     textStyle: {
              //       color: "black",
              //     },
              //   },
              // },
              // areaColor: "#409EFF",
              // color: "#fff",
              // zoom: 1, // 地图缩放比例,默认为1
              // emphasis: {
              //   // 是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
              //   label: { show: true },
              // },
            },
            // label: {
            //   normal: {
            //     show: true, // 显示省份标签
            //     textStyle: { color: "#fff" }, // 省份标签字体颜色
            //   },
            //   emphasis: {
            //     show: true,
            //     textStyle: {},
            //   },
            // },
            data: mapData,
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            rippleEffect: {
              brushType: 'fill',
              scale: 2,
            },
            showEffectOn: 'render',
            itemStyle: {
              color: '#409EFF',
            },
            label: {
              normal: {
                show: true,
                color: '#fff', // 字体颜色
                position: 'inside',
                padding: [0, 0, 0, 0],
                verticalAlign: 'middle',
                formatter: function (para) {
                  return para.data.num
                },
              },
            },
            symbol: 'circle',
            // symbolRotate: 20,
            symbolSize: [10, 10],
            data: eData,
            // zlevel: 1,
          },
        ],
      }
      this.chinaMap.setOption(this.options)
      this.chinaMapHidden(this.chinaMap)
    },
    // 中国地图点击省份 显示当前省份的详细的地区。
    chinaMapHidden(chinaMap) {
      const that = this
      chinaMap.off('click')
      chinaMap.on('click', async function (params) {
        console.log(params)
        if (!params.data.value) return that.$message.error('当前地区暂无数据')
        // 是否为点击省份
        if (params.name in that.provinces) {
          console.log('2222222222')
          that.ProvincesName = params.name
          that.ProvincesId = params.data.Id
          that.Level = 1
          that.AreaType = '省份'
          const s = await import(`./province/${that.provinces[params.name]}.js`)
          if (s) {
            that.params = params
            // 获取市级信息
            that.getCityList(params)
          }
        } else {
          that.projectDrawer = true
          that.DrawerList = []
          that.ProvincesName = params.name
          that.getprojectDrawerData()
          console.log(333333333333333)
        }
      })
    },
    getMapData() {
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetProjectListForMap', {
          Level: '1',
          ParentId: '',
        })
        .then((res) => {
          if (res.Success) {
            const mapData = res.Data
            // const eData = res.Data.eData;
            const eData = mapData.map((item) => ({
              name: item.name,
              value: [item.Longitude, item.Latitude],
              num: item.value,
              visualMap: false,
              Id: item.Id,
            }))
            this.chinaMaprsult('china', mapData, eData)
          }
        })
    },
    handleMap(ist) {
      if (ist == this.MapFlag) {
        return
      }
      this.MapFlag = ist
      if (this.MapFlag) {
        this.$nextTick(() => {
          this.getMapData()
        })
      } else {
        this.Level = 0
        this.chinaMap.dispose()
        this.chinaMap = null
        this.queryParam.Keyword = ''
        this.pagination.PageIndex = 1
        this.search()
      }
    },
    // 更换省份
    changeProvince(e) {
      this.$set(this.entity, 'City', '')
      console.log(e)
      let id = this.ProvinceLsit.find((item) => item.Name == e).Id
      this.getCityLsit(id)
    },
    // 获取省份信息
    async getProvince() {
      await this.$http
        .post('/Base_BasicData/Base_District/GetDistrictList')
        .then((res) => {
          this.ProvinceLsit = res.Data
        })
    },
    // 获取市/区信息
    async getCityLsit(pid) {
      await this.$http
        .post('/Base_BasicData/Base_District/GetDistrictList?ParentId=' + pid)
        .then((res) => {
          this.CityLsit = res.Data
        })
    },
    close() {
      this.drawer = false
    },
    SaveAdd() {
      this.$refs.entity.validate((valid) => {
        if (!valid) {
          return
        }
        this.formLoading = true
        this.$http
          .post('/Base_ProjectWork/Base_Project/SaveData', {
            ...this.entity,
          })
          .then((res) => {
            this.formLoading = false
            if (res.Success) {
              this.$router.push('/ProjectInfo?id=' + res.Data.Id)
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    getSelectList() {
      let arr = ['ProjectType', 'SupplierQualifications']
      arr.forEach((item) => {
        this.$http
          .post(
            '/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey',
            {
              Condition: 'DicKey',
              Keyword: item,
            }
          )
          .then((res) => {
            if (res.Success)
              this[item + 'List'] = res.Data.DictionaryDetailsList
          })
      })
    },
    // 新建项目
    handleAdd() {
      this.drawer = true
      this.getSelectList()
      this.$nextTick(() => {
        this.entity = {
          ProjectImg: '',
          Name: '',
          SimplifiedCode: '',
          Describe: '',
          Province: '',
          City: '',
          ProjectType: '',
          TotalArea: '',
          OpeningTime: '',
          PlannedCompletionDate: '',
          HandoverTime: '',
          ProjectManagerId: '',
          Property_Company: '',
          Property_Manager: '',
          ConstructionUnit: '',
          ConstructionManager: '',
          ConstructionPhone: '',
          Contact_Phone: '',
          PMCId: '',
          SupplierQualificationsList: [],
        }
        this.$refs.entity.resetFields()
        this.$set(this.entity, 'ProjectManagerId', this.userInfo.Id)
        this.$set(
          this.entity,
          'ProjectImg',
          'https://oss.zytsaas.com/DeviceProjectInfo/Project.jpg'
        )
      })
    },
    // 查看项目
    handleView(item) {
      let pId = item.ProjectId || item.Id
      this.$router.push('/ProjectInfo?id=' + pId)
    },
    mouseover(item) {
      this.$set(item, 'isHover', true)
    },
    mouseout(item) {
      this.$set(item, 'isHover', false)
    },
    querySearch(queryString, cb) {
      const restaurants = this.restaurants
      const results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    currentChange(pageIndex) {
      this.pagination.PageIndex = pageIndex
      // this.pagination.PageRows = data.pageSize;
      this.getDataList()
    },
    handleSizeChange(pageSize) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = pageSize
      this.getDataList()
    },
    getProjectRecordDataList() {
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetProjectRecordDataList', {
          PageIndex: 1,
          PageRows: 10,
          SortField: 'UpdateTime',
          SortType: 'desc',
        })
        .then((res) => {
          if (res.Success) {
            this.ProjectRecordDataList = res.Data
          }
        })
    },
    getDataList() {
      this.isSearch = false
      // const that = this;
      this.loading = true
      // this.isShow = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetProjectDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: this.pagination.SortField,
          SortType: this.pagination.SortType,
          search: this.queryParam,
        })
        .then((res) => {
          this.pagination.total = res.Total
          if (res.Success) {
            this.loading = false
            if (res.Data == null) {
              this.List = []
              return
            }
            this.List = res.Data
            this.$nextTick(() => {
              this.$refs.List.scrollTop = 0
            })
            // this.isShow = true
          }
        })
      this.getProjectStatistics()
      // this.getProjectRecordDataList();
    },
    search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    // 删除项目
    handleDel(obj, num) {
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .post('/Base_ProjectWork/Base_Project/AppDeleteData?Id=' + obj.Id)
            .then((res) => {
              if (res.Success) {
                if (num === '1') {
                  this.getCityList(this.params)
                  this.getprojectDrawerData()
                } else {
                  this.getDataList()
                }

                this.$notify.success('操作成功')
              } else this.$notify.error(res.Msg)
            })
        })
        .catch(() => {})
    },
    // 收藏项目
    collectProject(item) {
      this.$http
        .post('/Base_ProjectWork/Base_ProjectCollect/SaveData', {
          ProjectId: item.Id,
          UserId: this.vipuser.Id,
        })
        .then((res) => {
          if (res.Success) {
            item.IsCollect = true
            // this.$notify.success("操作成功");
          } else this.$notify.error(res.Msg)
        })
    },
    // 取消收藏项目
    collectCancelProject(item) {
      this.$http
        .post('/Base_ProjectWork/Base_ProjectCollect/DeleteDataByCondition', [
          { Condition: 'ProjectId', Keyword: item.Id },
          { Condition: 'UserId', Keyword: this.vipuser.Id },
        ])
        .then((res) => {
          if (res.Success) {
            item.IsCollect = false
            // this.$notify.success("操作成功");
          } else this.$notify.error(res.Msg)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.homeTamplate {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.homefixed {
  position: fixed;
  width: 100%;
  height: 60px;
  left: 0px;
  top: 61px;
  z-index: 999;
  display: flex;
  padding: 0 10px;
  background: #ebeef5;
  box-sizing: border-box;
  align-items: center;
  .searchInput {
    width: 50%;
    display: flex;
    align-items: center;
    .el-input__inner {
      border-radius: 5px 0 0 5px;
    }
    .btn {
      border-radius: 0 5px 5px 0;
    }
  }
  .tabfixed {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: right;
  }
}
.MapData {
  width: 100%;
  height: calc(100vh - 100px);
  position: relative;
}
.List {
  width: 100%;
  min-width: 900px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  // display: flex;
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
  box-sizing: border-box;
}
.logoBox {
  // margin-bottom: 10px;
}
// .searchInput {
//   width: 50%
//   // height: 60px;
//   // position: fixed;
//   // top: 61px;
//   // left: 10px;
//   // z-index: 1000;
//   background-color: white;
//   display: flex;
//   align-items: center;
//   .el-input__inner {
//     border-radius: 5px 0 0 5px;
//   }
//   .btn {
//     border-radius: 0 5px 5px 0;
//   }
// }
.ellipsis3 {
  overflow: hidden; //超出隐藏

  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: normal;
  -webkit-line-clamp: 3; //内容限制的行数
}
::v-deep .el-drawer__body {
  position: relative;
}
.delIcon {
  display: block;
  background: rgba(255, 0, 0, 0.6);
  width: 30px;
  height: 25px;
  line-height: 22px;
  text-align: center;
  font-size: 20px;
  border-radius: 0 0 0 10%;
  cursor: pointer;
  transition: all 100ms linear 0s;
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 998;
  opacity: 0;
  color: white;

  &:hover {
    color: white;
    background: rgba(255, 0, 0, 1);
  }
}
.mapnone {
  display: none;
}
::v-deep .avatar-uploader .el-upload {
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.history {
  position: fixed;
  top: 70px;
  left: calc(50% + 200px);
  width: 300px;
  overflow-y: auto;
  height: calc(80%);
}
::v-deep .el-statistic {
  // text-align-last: left;
  .head {
    font-size: 14px;
    font-weight: bold;
  }
  .con {
    // justify-content: left;
    .number {
      font-size: 20px;
    }
  }
}
::v-deep .el-timeline-item__timestamp {
  font-size: 16px;
}
::v-deep .labelClassName {
  width: 80px;
}
.circle-stat {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: 0 auto;
}
::v-deep .header-row {
  background: #fff;

  .el-table__cell {
    font-weight: bold;
    color: #000;

    .cell {
      padding: 10px;
      border-radius: 6px;
      width: auto;
      min-width: 150px;
      font-size: 18px !important;
      text-align: center;
    }
  }
}
// ::v-deep .el-table__body-wrapper .el-table__cell {
//   border-bottom: none !important;
// }
::v-deep .row {
  cursor: pointer;
}

::v-deep .Describe {
  height: auto;
}
::v-deep .el-tag--medium {
  font-weight: bold;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  height: 40px;
}
</style>
